import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

class DaySelector extends PureComponent {
    static propTypes = {
        selectedDays: PropTypes.array,
        onChange: PropTypes.func
    };

    _isSelected = (value) => {
        const { selectedDays } = this.props;
        for (let i = 0; i < selectedDays.length; i += 1) {
            if (value === selectedDays[i]) {
                return true;
            }
        }
        return false;
    };

    render() {
        const { onChange } = this.props;
        const days = [
            {
                title: 'Monday',
                value: 'MO'
            },
            {
                title: 'Tuesday',
                value: 'TU'
            },
            {
                title: 'Wednesday',
                value: 'WE'
            },
            {
                title: 'Thursday',
                value: 'TH'
            },
            {
                title: 'Friday',
                value: 'FR'
            }
        ];
        return (
            <div className={`day-selector`}>
                {days.map((item) => (
                    <div
                        className={cns(`day-selector-option`, { selected: this._isSelected(item.value) })}
                        onClick={() => onChange(item.value)}
                    >
                        <div className={`day-selector-option-select`} />
                        {item.title}
                    </div>
                ))}
            </div>
        );
    }
}

export default DaySelector;
